import React from "react";
import { Flex, Typography } from "antd";

const { Title } = Typography;

const Dashboard: React.FC = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
      }}
    >
      <img src="/logo.png" alt="Logo" style={{ width: 200 }} />
      <Flex vertical align="center" justify="center" style={{ height: "100%" }}>
        <Title level={2}>Dashboard</Title>
        <p>Welcome to your admin dashboard!</p>
      </Flex>
    </div>
  );
};

export default Dashboard;
